


import { Component, Vue } from 'vue-property-decorator';
import CompleteStep from '@/utils/mixins/completeStep';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { Floor, Zone } from '../../utils/api';
import { namespace } from 'vuex-class';
import ConfContainer from '../../components/ConfContainer/index.vue';
import { SelectType } from '../../components/SelectionPanel/SelectionPanel.models';
import { RenderMode } from '../../components/ConfContainer/ConfContainer.models';
import { EnablerOptions } from '@/components/ConfContainer/index.vue';

const atticModule = namespace('attic');
const roofShapeModule = namespace('roofShape');
const configurationModule = namespace('configuration');

@Component({
  components: {
    ConfContainer
  },
  mixins: [CompleteStep, PageTransitionMode]
})
export default class Attic extends Vue {
  @atticModule.Getter private floor!: Floor;
  @atticModule.Getter private activeZone!: Zone;
  @roofShapeModule.State private floorID!: string;
  @roofShapeModule.State private zoneID!: string;

  @atticModule.Action private selectModule!: (moduleID: string) => void;
  @configurationModule.Action private setVisitedZones!: (zoneID: string) => void;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;

  private mounted() {
    this.setVisitedZones(this.floor.zones[0].ID);
  }

  private get enablerOptions(): EnablerOptions {
    return {
      floorID: this.floorID,
      zoneID: this.zoneID,
      moduleID: 'RO-04'
    };
  }
}
